import React from 'react';
import { AlertCircle, CheckCircle, ArrowUpCircle, ArrowDownCircle } from 'lucide-react';
import { controllaQuadratura, formattaValuta } from '../utils/contabilita';

const RiepilogoQuadratura = ({ dettagli }) => {
  const controllo = controllaQuadratura(dettagli);

  return (
    <div className={`border rounded-lg p-4 ${
      controllo.isQuadrato 
        ? 'border-green-200 bg-green-50' 
        : 'border-red-200 bg-red-50'
    }`}>
      <div className="flex items-center justify-between">
        <div className="flex items-center space-x-2">
          {controllo.isQuadrato ? (
            <CheckCircle className="w-5 h-5 text-green-600" />
          ) : (
            <AlertCircle className="w-5 h-5 text-red-600" />
          )}
          <h3 className={`font-medium ${
            controllo.isQuadrato ? 'text-green-800' : 'text-red-800'
          }`}>
            Quadratura Transazione
          </h3>
        </div>
        
        {!controllo.isQuadrato && (
          <span className="text-sm font-medium text-red-600">
            {controllo.errore}
          </span>
        )}
      </div>

      <div className="mt-3 grid grid-cols-3 gap-4">
        <div className="text-center">
          <div className="flex items-center justify-center space-x-1 text-red-600">
            <ArrowUpCircle className="w-4 h-4" />
            <span className="text-xs font-medium">DARE</span>
          </div>
          <div className="text-lg font-bold text-red-700">
            {formattaValuta(controllo.sommaDare)}
          </div>
        </div>

        <div className="text-center">
          <div className="flex items-center justify-center space-x-1 text-green-600">
            <ArrowDownCircle className="w-4 h-4" />
            <span className="text-xs font-medium">AVERE</span>
          </div>
          <div className="text-lg font-bold text-green-700">
            {formattaValuta(controllo.sommaAvere)}
          </div>
        </div>

        <div className="text-center">
          <div className="text-xs font-medium text-gray-600">Sbilancio</div>
          <div className={`text-lg font-bold ${
            controllo.isQuadrato ? 'text-green-700' : 'text-red-700'
          }`}>
            {formattaValuta(Math.abs(controllo.sbilancio))}
          </div>
        </div>
      </div>

      {!controllo.isQuadrato && (
        <div className="mt-3 text-xs text-red-600 bg-red-100 rounded p-2">
          <strong>Attenzione:</strong> La transazione non è quadrata. 
          La somma dei DARE deve essere uguale alla somma degli AVERE.
        </div>
      )}
    </div>
  );
};

export default RiepilogoQuadratura;
